import * as React from 'react';

import GoogleMarkup from 'bundles/seo/components/GoogleMarkup';
import {
  createBreadcrumbsListSchema,
  createCollectionPageSchema,
  createGraph,
  createOrganizationSchema,
  createWebsiteSchema,
} from 'bundles/shared-articles/components/seo/utils/schemaMarkupUtils';
import type { Breadcrumb } from 'bundles/shared-articles/components/seo/utils/schemaMarkupUtils';

type Props = {
  categoryPageUrl: string; // Absolute URL of category page
  categoryPageName: string; // Category page name
  categoryBreadcrumbList: Breadcrumb[];
};

const CategoryPageGoogleSchemaMarkup = ({ categoryPageUrl, categoryPageName, categoryBreadcrumbList }: Props) => {
  const collectionPageType = createCollectionPageSchema({
    name: categoryPageName,
    url: categoryPageUrl,
  });
  const websiteType = createWebsiteSchema();
  const organizationType = createOrganizationSchema();

  return (
    <div className="rc-CategoryPageGoogleSchemaMarkup" data-testid="CategoryPageGoogleSchemaMarkup">
      <GoogleMarkup
        graph={createGraph([
          collectionPageType,
          websiteType,
          organizationType,
          createBreadcrumbsListSchema(categoryBreadcrumbList),
        ])}
      />
    </div>
  );
};

export default CategoryPageGoogleSchemaMarkup;
